@if (passFound && !loading) {
  <div slot="content">
    <ix-layout-grid class="h-100 w-100 position-relative" columns="12">
      <ix-row>
        <ix-col>
          <ix-content-header
            id="genericSubmodelViewerHeader"
            [hasBackButton]="true"
            (backButtonClick)="onBackButtonClick()"
            [headerTitle]="submodelName"
          >
            <ix-pill slot="header" class="margin-top">{{
              submodelVersion ? 'v' + submodelVersion : undefined
            }}</ix-pill>
          </ix-content-header>
        </ix-col>
      </ix-row>
      <div class="key-value-list-wrapper">
        <ix-key-value-list>
          @for (
            element of submodel?.submodelElements ?? [];
            track element.idShort
          ) {
            <app-dpp-submodel-field [element]="element" />
          }
        </ix-key-value-list>
      </div>

      <ix-row>
        <ix-col>
          <div class="d-flex flex-column align-items-center text-center gap-2 mt-3 mb-4">
            <ix-typography format="body-lg" id="publicDppSubmodelLoginLabel">
              {{ 'battery_pass.public.login_text' | translate }}
            </ix-typography>
            <ix-button
              variant="primary"
              [routerLink]="['/app/dpp/view-passport', dppId, 'submodel', submodelId]"
              id="publicDppSubmodelLoginButton"
            >
              {{ 'general.login' | translate }}
            </ix-button>
          </div>
        </ix-col>
      </ix-row>
    </ix-layout-grid>
  </div>
}

@if (loading) {
  <div class="d-flex justify-content-center">
    <ix-spinner size="large" class="mt-5"></ix-spinner>
  </div>
}

@if (!passFound) {
  <div class="d-flex justify-content-center">
    <ix-empty-state
      class="mt-5"
      header="{{ 'battery_pass.list.no_passport_available' | translate }}"
      subHeader="{{ 'battery_pass.private.no_pass_sub_header' | translate }}"
      icon="error"
      action="{{ 'battery_pass.public.action' | translate }}"
    ></ix-empty-state>
  </div>
}
